import { LOGO_SRC_BY_VARIANT } from './logo.constants';
import type { LogoColor, LogoState } from './logo.types';

export function getLogoSrc(color: LogoColor, state: LogoState): string {
  return LOGO_SRC_BY_VARIANT[color][state];
}
